module.exports = __webpack_public_path__ + "img/clue04_bg.c50351eb.png";